import React, { useState, useEffect } from 'react';
import { useAcceptanceChangeStore } from 'src/store/acceptance-change';
import { useAuthStore } from 'src/store/auth';
import { Modal } from '../Modal';
import './AcceptanceWarningModal.scss';

export const AcceptanceWarningModal: React.FC = () => {
  const {
    isModalOpen,
    setModalOpen,
    resetAcceptance,
    // checkApplicationStatus,
    setDontShowAgain,
  } = useAcceptanceChangeStore();
  
  const { isAuthenticated } = useAuthStore();
  const [isProcessing, setIsProcessing] = useState(false);

  // Check application status on mount
  useEffect(() => {
    if (isAuthenticated) {
      console.log('checkApplicationStatus', isAuthenticated)
      // checkApplicationStatus(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const handleProceed = async () => {
    setIsProcessing(true);
    try {
      await resetAcceptance();
      setModalOpen(false);
    } catch (error) {
      console.error('Failed to reset acceptance:', error);
    } finally {
      window.location.reload();
      setIsProcessing(false);
    }
  };

  // const handleCancel = () => {
  //   setModalOpen(false);
  // };

  const handleClose = () => {
    setModalOpen(false);
  };

  // const handleDontShowAgain = () => {
  //   setDontShowAgain();
  // };

  if (!isModalOpen) return null;

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose} className="acceptance-warning-modal">
      <div className="acceptance-warning">
        <div className="acceptance-warning__image">
          <img 
            src="/images/modalUnderReview.jpg" 
            alt="Application changes warning"
            className="acceptance-warning__image-content"
          />
          <h2 className="acceptance-warning__title">
            Changes in the form can cause<br />underwriting...
          </h2>
        </div>

        <div className="acceptance-warning__content">
          <div className="acceptance-warning__text">
            <p className="acceptance-warning__paragraph">
              By clicking on Proceed the underwriting will be required again!
            </p>
            <p className="acceptance-warning__paragraph">
              This means your application will need to be reviewed again before you can proceed with signing and purchasing insurance.
            </p>
          </div>

          <div className="acceptance-warning__actions">
            <button 
              className="acceptance-warning__button acceptance-warning__button--cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button 
              className="acceptance-warning__button acceptance-warning__button--proceed"
              onClick={handleProceed}
              disabled={isProcessing}
            >
              {isProcessing ? 'Processing...' : 'Proceed'}
            </button>
          </div>

          {/* <button 
            className="acceptance-warning__dont-show"
            onClick={handleDontShowAgain}
            disabled={isProcessing}
          >
            Don't show this message again
          </button> */}
        </div>
      </div>
    </Modal>
  );
};
